import { render, staticRenderFns } from "./UserCreateBody.vue?vue&type=template&id=529b7ed2&scoped=true"
import script from "./UserCreateBody.vue?vue&type=script&lang=js"
export * from "./UserCreateBody.vue?vue&type=script&lang=js"
import style0 from "./UserCreateBody.vue?vue&type=style&index=0&id=529b7ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529b7ed2",
  null
  
)

export default component.exports